import { z } from 'zod'

// 会話の対象にできる view。runtime の run の page と同じ形（salescore-agent-runtime の DESIGN.md の「POST /invocations の要求」）
export const viewPageSchema = z.object({
  // SALESCORE の ViewConfigType のうち、MCP のツールで読めるもの（kpiPivot はダッシュボード）
  type: z.enum(['kpi', 'kpiPivot', 'sheet']),
  id: z.string(),
  name: z.string(),
})

export type ViewPage = z.infer<typeof viewPageSchema>

// 画面が POST .../turns で送る会話の対象。viewId だけを送り、種別と名前は BE が引き直す
export const viewPageTargetSchema = z.object({ id: z.string().min(1) })
